<template>
  <nav>
    <v-navigation-drawer v-model="$store.state.drawer" app class="primary">
      <v-list-item two-line v-if="$store.state.authUser">
        <v-list-item-content>
          <v-img
            id="navDrawerLogo"
            src="@/assets/logo-neg.svg"
            alt="logo"
            contain
            height="100"
          />
          <v-list-item-title class="grey--text text--lighten-4">
            {{ $store.state.authUser.email }}
          </v-list-item-title>
          <v-list-item-subtitle class="grey--text text--lighten-4">
            Logged in
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="grey"></v-divider>

      <v-list>
        <v-list-item-group color="primary" v-if="$store.state.partnerEnvironment !== null">
          <v-list-item v-for="(link, i) in links" :key="i" router :to="link.route" active-class="teal darken-3">
            <v-list-item-icon>
              <v-icon class="white--text" v-text="link.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text" v-text="link.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-divider class="grey"></v-divider>

      <template v-slot:append v-if="$store.state.authUser">
        <v-divider class="grey"></v-divider>

        <v-list>
          <v-list-item-group>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon class="grey--text text--lighten-4">mdi-exit-to-app</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--lighten-4">Signout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </template>

    </v-navigation-drawer>
  </nav>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NavDrawer',

  data: () => ({
    links: [
      { icon: 'mdi-view-dashboard', title: 'Dashboard', route: '/' },
      { icon: 'mdi-format-list-bulleted', title: 'All Items', route: '/items' },
      { icon: 'mdi-database-edit', title: 'Mass Edit', route: '/editItems' },
      { icon: 'mdi-account-supervisor', title: 'New Customer', route: '/customers' }
    ]
  }),

  methods: {
    async logout () {
      console.log('logout() triggered')
      try {
        axios.get(process.env.VUE_APP_API_URL + '/logout')
      } catch (err) {
        console.error('Error trying to logout axios.get()', err)
      }
    }
  }
}
</script>

<style>
.navbarActive {
  background-color: teal;
}

#navDrawerLogo {
  margin: 15px 0 20px 0;
}
</style>
